/**
 * Get browser and OS information for User-Agent header
 */
function getBrowserInfo() {
  const ua = navigator.userAgent;
  let browser = "Unknown";
  let version = "";

  // Detect browser
  if (ua.indexOf("Chrome") > -1 && ua.indexOf("Edg") === -1) {
    browser = "Chrome";
    const match = ua.match(/Chrome\/(\d+)/);

    version = match ? match[1] : "";
  } else if (ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") === -1) {
    browser = "Safari";
    const match = ua.match(/Version\/(\d+)/);

    version = match ? match[1] : "";
  } else if (ua.indexOf("Firefox") > -1) {
    browser = "Firefox";
    const match = ua.match(/Firefox\/(\d+)/);

    version = match ? match[1] : "";
  } else if (ua.indexOf("Edg") > -1) {
    browser = "Edge";
    const match = ua.match(/Edg\/(\d+)/);

    version = match ? match[1] : "";
  }

  return version ? `${browser}/${version}` : browser;
}

function getOSInfo() {
  const ua = navigator.userAgent;
  let os = "Unknown";

  if (ua.indexOf("Win") > -1) {
    os = "Windows";
  } else if (ua.indexOf("Mac") > -1) {
    os = "macOS";
  } else if (ua.indexOf("X11") > -1 || ua.indexOf("Linux") > -1) {
    os = "Linux";
  } else if (ua.indexOf("Android") > -1) {
    os = "Android";
  } else if (ua.indexOf("iOS") > -1 || ua.indexOf("iPhone") > -1) {
    os = "iOS";
  }

  return os;
}

function getDeviceType() {
  const ua = navigator.userAgent;

  // Check for mobile devices
  if (/Mobile|Android|iPhone|iPad|iPod/i.test(ua)) {
    if (/iPad/i.test(ua)) {
      return "Tablet";
    }

    return "Mobile";
  }

  // Check for TV devices
  if (/TV|SmartTV|GoogleTV|AppleTV/i.test(ua)) {
    return "TV";
  }

  return "Web";
}

/**
 * Generate User-Agent string for Lunova Web Player
 * Format: LunovaWebPlayer/{version} ({deviceType} {os}; {browser})
 *
 * Similar to Android TV format:
 * LunovaWebPlayer/1.0.0 (AndroidTV 13; Samsung SM-T500)
 *
 * Web format examples:
 * LunovaWebPlayer/1.0.0 (Web macOS; Chrome/120)
 * LunovaWebPlayer/1.0.0 (Mobile iOS; Safari/17)
 */
export function getUserAgent() {
  const appVersion = process.env.REACT_APP_VERSION || "1.0.0";
  const deviceType = getDeviceType();
  const browser = getBrowserInfo();
  const os = getOSInfo();

  return `LunovaWebPlayer/${appVersion} (${deviceType} ${os}; ${browser})`;
}
